import Vue from "vue";

import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import About from "../views/About.vue";
import Module from "../views/Module.vue";
import Image from "../views/Image.vue";
import Video from "../views/Video.vue";
import Catalogue from "../views/Catalogue.vue";
import Series from "../views/Series.vue";
import Scene from "../views/Scene.vue";
import SerieList from "../views/SerieList.vue";

import Material from "../views/Material.vue";
import Wood from "../views/Wood.vue";
import Metal from "../views/Metal.vue";
import Fabric from "../views/Fabric.vue";
import Single from "../views/Single.vue";
import Idea from "../views/Idea.vue";
import Service from "../views/Service.vue";
import Projects from "../views/Projects.vue";
import SingleNews from "../views/SingleNews.vue";
import SingleIdea from "../views/SingleIdea.vue";

Vue.use(VueRouter);

const routes = [
  { path: "/", name: "Home", component: Home },
  { path: "/series", name: "SerieList", component: SerieList },
  { path: "/series/:id", name: "Series", component: Series },
  { path: "/scene/:id", name: "Scene", component: Scene },
  { path: "/single", name: "Single", component: Single },

  { path: "/material", name: "Material", component: Material },

  { path: "/woods", name: "Wood", component: Wood },
  { path: "/fabric", name: "Fabric", component: Fabric },
  { path: "/fabric/:id", name: "FabricCat", component: Fabric },
  { path: "/metal", name: "Metal", component: Metal },
  { path: "/module", name: "Module", component: Module },
  { path: "/image", name: "Image", component: Image },
  { path: "/video", name: "Video", component: Video },
  { path: "/catalogue", name: "Catalog", component: Catalogue },
  { path: "/service", name: "Service", component: Service },
  { path: "/about", name: "About", component: About },
  { path: "/projects", name: "Projects", component: Projects },

  { path: "/news/:id", name: "SingleNews", component: SingleNews },

  { path: "/idea", name: "Idea", component: Idea },
  { path: "/idea/:id", name: "SingleIdea", component: SingleIdea },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.afterEach((to, from, next) => {
  window, scrollTo(0, 0)
})

// router.beforeEach((to, from) => {
//   EventBus.$emit('hideMegaMenu')
// })

export default router;
